export const showLoading = (type, message) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_IS_LOADING",
      payload: true,
    });
  };
};

export const closeLoading = () => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_IS_LOADING",
      payload: false,
    });
  };
};

export const updateCurrentAdmin = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_CURRENT_ADMIN",
      payload: data,
    });
  };
};

export const updateSessionExpired = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_SESSION_EXPIRED",
      payload: data,
    });
  };
};

export const updateCurrentSection = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: "UPDATE_CURRENT_SECTION",
      payload: data,
    });
  };
};
